<template>
  <div id="app">
    <RCCard/>
  </div>
</template>

<script>
import RCCard from "@/components/RCCard";

export default {
  name: 'App',
  components: {
    RCCard
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  padding: 0;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  &::after {
    content: "";
    background-image: url('/RCcardBG.jpg');
    background-repeat: repeat;
    background-size: 10%;
    opacity: 0.15;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
}
</style>
